import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import "../../assets/styles/local/ProjectWork.css";
import { Image, Row, Col } from "react-bootstrap";
import DownArrowOption from "../../assets/icons/DownArrowOption.svg";
import blackDoller from "../../assets/icons/blackDoller.svg";
import bin from "../../assets/icons/Bin.svg";
import changeIcon from "../../assets/icons/Group 2752.svg";
import Kebab from "../..//assets/icons/Kebab contacts.svg";
import Plusicon from "../../assets/icons/Plus.svg";
import XiconCircle from "../../assets/icons/x-circle.svg";
import calendar from "../../assets/icons/calendar.svg";
import Xicon from "../../assets/icons/Xicon.svg";
import upArrow from "../../assets/icons/upArrow.png";
import CardAddButton from "../../assets/icons/CardAddButton.svg";
import plusCircle from "../../assets/icons/plusCircle.svg";
import Loader from "../../components/Dailogs/Loader";
import AppDatePicker from "../../components/Common/AppDatePicker";
import moment from "moment";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import CurrencyInput from "react-currency-input";
import StockAssigneeModal from "../../pages/dynamic/StockAssigneeModal";
import { toast } from "react-toastify";
import LogoSmall from "../../assets/images/logo-small.png";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

import {
  FetchProjectHiring,
  ProjectHireCreate,
  ProjectHireUpdate,
  ProjectHireDelete,
  UpdateProjectHiringStatus,
  UpdateProjectHiringExtendPeriod,
  // DeleteWork,
  // AddWorkTask,
  // DeleteWorkTask,
  // FetchActiveUser,
  // ChangeStatus,
  // UpdatePOTaskStatus,
  // FetchWorkById,
  // UpdateWorkTask,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../../components/Pagination/Pagination";
import axios from "axios";
import { API_URL } from "../../redux/constants/type";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";

const AddProjectHiring = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const startingDate_Popup_Ref = useRef(null);
  const complitionDate_Popup_Ref = useRef(null);
  const kebab_Popup_Ref = useRef(null);
  const sortByRef = useRef(null);

  const companyId = window.localStorage.getItem("companyid");
  const userId = window.localStorage.getItem("userid");
  const roleAccess = window.localStorage.getItem("roleid");
  const projectid = window.localStorage.getItem("projectid");
  const projectcode = window.localStorage.getItem("projectcode");
  const firstname = window.localStorage.getItem("firstname");
  const isViewer = process.env.REACT_APP_IS_VIEWER;
  console.log("ASC56 Role ENV", isViewer);
  const toastIdRef = React.useRef(null);

  const projectHireListRes = useSelector(
    (state) => state.user.projectHireListRes
  );

  const projectHireCreateRes = useSelector(
    (state) => state.user.projectHireCreateRes
  );

  const projectHireUpdateRes = useSelector(
    (state) => state.user.projectHireUpdateRes
  );

  const projectHireDeleteRes = useSelector(
    (state) => state.user.projectHireDeleteRes
  );

  const UpdateProjectHiringStatusRes = useSelector(
    (state) => state.user.UpdateProjectHiringStatusRes
  );

  const UpdateProjectHiringExtendPeriodRes = useSelector(
    (state) => state.user.UpdateProjectHiringExtendPeriodRes
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add-Project").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  // variables state management start
  const [hovereff, setHovereff] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [projectHiringListData, setProjectHiringListData] = useState([]);
  const [kebabPopupShow, setKebabPopupShow] = useState(false);
  const [addTaskModalShow, setAddTaskModalShow] = useState(false);
  console.log("asc56", addTaskModalShow);

  // Header hiring update variables for kebab start.
  const [selectedProjectHiringID, setSelectedProjectHiringID] = useState("");
  const [changeStatusPopup, setChangeStatusPopup] = useState(false);
  // status by start.
  const [arrowOptionsRotate3, setArrowOptionsRotate3] = useState(false);
  const [statusShow, setStatusShow] = useState(false);
  const [status, setStatus] = useState("Select...");
  // status by end.

  const [extendPeriodPopup, setExtendPeriodPopup] = useState(false);
  const [chargeClient, setChargeClient] = useState(false);
  const [calendarIsOpen, setCalendarIsOpen] = useState(false);
  const [calendarIsOpen2, setCalendarIsOpen2] = useState(false);
  const [startingDate, setStartingDate] = useState(new Date());
  const [endingDate, setEndingDate] = useState(new Date());
  const [dateError, setDateError] = useState(false);
  const [createdat, setCreatedat] = useState(new Date());
  const [wageRate, setWageRate] = useState("");
  const [wageType, setWageType] = useState("");
  const [projectHiringID, setProjectHiringID] = useState("");
  const [hiringID, setHiringID] = useState("");
  // Header hiring update variables for kebab end.

  useEffect(() => {
    if (projectHireListRes.status === true) {
      setProjectHiringListData(projectHireListRes.data);
      setShowLoader(false);
    }
  }, [projectHireListRes]);

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      kebab_Popup_Ref.current &&
      !kebab_Popup_Ref.current.contains(event.target)
    ) {
      setKebabPopupShow(false);
      setArrowOptionsRotate(false);
    }

    if (sortByRef.current && !sortByRef.current.contains(event.target)) {
      setShowShortDrop(false);
    }

    if (
      startingDate_Popup_Ref.current &&
      !startingDate_Popup_Ref.current.contains(event.target)
    ) {
      setCalendarIsOpen(false);
    }
    if (
      complitionDate_Popup_Ref.current &&
      !complitionDate_Popup_Ref.current.contains(event.target)
    ) {
      setCalendarIsOpen2(false);
    }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  const [arrowOptionsRotate, setArrowOptionsRotate] = useState(false);
  const [companyShow, setCompanyShow] = useState(false);
  const [viewByTxtShow, setViewByTxtShow] = useState("Company");

  const [workID, setWorkID] = useState("");
  const [createWorkPopup, setCreateWorkPopup] = useState(false);

  const [sortBy, setSortBy] = useState("");
  const [querystring, setQuerystring] = useState("");
  const [isUpdateTime, setIsUpdateTime] = useState(false);

  // for sort by
  const [shortByArrow, setShortByArrow] = useState(false);
  const [showShortDrop, setShowShortDrop] = useState(false);
  const [sortedValue, setSortedValue] = useState("Start Date");

  // sort by options start
  const sortByOption = [
    { label: "Start Date", value: "Start Date" },
    { label: "End Date", value: "End Date" },
    { label: "Assignee", value: "Assignee" },
    { label: "Equipment", value: "Equipment" },
  ];
  // sort by options end

  useEffect(() => {
    const sortedPayload = shortByArrow
      ? `asc-${sortedValue}`
      : `dsc-${sortedValue}`;
    // dispatch(FetchProjectWorks(querystring, sortedPayload));
    // Usage in toast.update
    dispatch(FetchProjectHiring(projectid));
  }, [
    projectHireCreateRes,
    projectHireDeleteRes,
    UpdateProjectHiringStatusRes,
    UpdateProjectHiringExtendPeriodRes,
    querystring,
    sortBy,
    shortByArrow,
    sortedValue,
  ]);

  const [activeAllFromList, setActiveAllFromList] = useState(false);
  const [goComplete, setGoComplete] = useState("");

  // for complete Toggle start
  const [toggleComplete, setToggleComplete] = useState(false);
  const [ascTaskid, setAscTaskid] = useState("");
  const [currentIndex, setCurrentIndex] = useState(null);
  const [selectedToggle, setSelectedToggle] = useState([]);

  const [active, setActive] = useState(false);
  const [selectedTaskID, setSelectedTaskID] = useState("");
  console.log("asc563", selectedTaskID);
  // for complete Toggle end

  // header pagination start.
  const [paginationObj, setPaginationObj] = useState({
    totalRecords: 0,
    currentPage: 0,
    startRecordIndex: 0,
    endRecordIndex: 0,
    totalPages: 0,
    records: [],
  });
  const itemsPerPage = 10;
  const calculatePagination = (pageNumber) => {
    let records = projectHiringListData || [];
    let tempPaginationObj = {
      totalRecords: records.length,
      currentPage: pageNumber,
      startRecordIndex: Math.max(itemsPerPage * (pageNumber - 1) + 1, 1),
      endRecordIndex: Math.min(itemsPerPage * pageNumber, records.length),
      totalPages: Math.ceil(records.length / itemsPerPage),
      records: records.slice(
        (pageNumber - 1) * itemsPerPage,
        pageNumber * itemsPerPage
      ),
    };
    setPaginationObj({ ...paginationObj, ...tempPaginationObj });
  };
  useEffect(() => {
    calculatePagination(1);
  }, [projectHiringListData]);
  // header pagination end.

  // stock assignee modal start.
  const [openAssigneeModal, setOpenAssigneeModal] = useState(false);
  const [authorisedCoWorkerData, setAuthorisedCoWorkerData] = useState([
    // ...LocalAssineData,
  ]);
  const addUsersData = (asc, string) => {
    if (string === "single") {
      console.log("asc66", asc, string);
      setAuthorisedCoWorkerData([...authorisedCoWorkerData, asc]);
    }
    if (asc.length > 1) {
      // here ... will add and open asc array.
      setAuthorisedCoWorkerData([...authorisedCoWorkerData, ...asc]);
    }
  };

  const removeUsersData = (asc, string) => {
    if (string === "single") {
      let workers = authorisedCoWorkerData.filter((x) => x.id !== asc.id);
      setAuthorisedCoWorkerData(workers);
    }
    if (asc.length > 1) {
      let workers = authorisedCoWorkerData.filter(
        (x) => !asc.some((user) => user.id === x.id)
      );
      setAuthorisedCoWorkerData(workers);
    }
  };

  console.log("asc56 authData", authorisedCoWorkerData);
  // stock assignee modal end.

  useEffect(() => {
    if (authorisedCoWorkerData.length === 1) {
      setOpenAssigneeModal(false);
      setCreateWorkPopup(true);
    }
  }, [authorisedCoWorkerData]);

  const showNotification = () => {
    toast(
      <NotificationContent
        primaryMessage="The new hiring order was successfully done."
        secondaryMessage="The manager was notified to proceed with the hire."
      />,
      {
        icon: () => <img src={LogoSmall} alt="Logo" width={35} />,
        className: "app-notification",
        closeButton: true,
        autoClose: 3000,
        hideProgressBar: true,
      }
    );
  };

  return (
    <>
      {showLoader === true ? (
        <div
          className="text-center "
          style={{ color: "#003766", fontSize: "14px", fontWeight: "700" }}
        >
          <Loader />
        </div>
      ) : (
        <div className="parent pt-2 position-relative">
          <div>
            {openAssigneeModal && (
              <StockAssigneeModal
                sendingData={authorisedCoWorkerData} // only sending Data.
                addUsersData={addUsersData}
                removeUsersData={removeUsersData}
                closeAssigneeModal={setOpenAssigneeModal}
                // headerMaxAmount={headerMaxAmount}
                // setHeaderMaxAmount={setHeaderMaxAmount}
                showWorkersTab={true}
                showTeamsTab={false}
              />
            )}
          </div>
          <div className="outer w-100">
            <Row className="row-item px-4 pb-2">
              <Col xl={4} className="p-0">
                <div
                  onClick={() => {
                    // dispatch(RemoveDocsClientById());
                    setOpenAssigneeModal(!openAssigneeModal);
                  }}
                  className={
                    roleAccess === process.env.REACT_APP_IS_VIEWER
                      ? "pointer d-none"
                      : "pointer d-flex gap-2 p-3 pb-0"
                  }
                  style={{ borderRadius: "8px" }}
                >
                  <img src={CardAddButton} className="addDocImg" alt="" />
                  <p className="createWork pt-1">
                    {/* Add Hiring Order */}
                    {t("Add Hiring Order")}
                  </p>
                </div>
              </Col>

              <Col xl={4} className="p-0 invisible d-none d-xl-block">
                <sortSection
                  className="d-flex gap-3 p-3 pb-0"
                  style={{ position: "relative" }}
                >
                  <p className="sortBy">
                    {/* Sort by */}
                    {t("Sort By")}
                  </p>
                  <img
                    className={
                      shortByArrow
                        ? "downSortArrow mt-1 pointer"
                        : "upSortArrow mt-1 pointer"
                    }
                    src={upArrow}
                    alt=""
                    onClick={() => {
                      setShortByArrow(!shortByArrow);
                    }}
                  />

                  <p
                    ref={sortByRef}
                    className="datetext pointer"
                    onClick={() => setShowShortDrop(!showShortDrop)}
                  >
                    {sortedValue ? sortedValue : "Select"}
                  </p>

                  <div
                    className="sortDropDiv p-3"
                    style={{
                      transform: showShortDrop ? "scale(1)" : "scale(0)",
                      transitionDuration: "300ms",
                      left: "70px",
                      top: "0px",
                    }}
                  >
                    {sortByOption.map((item, index) => {
                      return (
                        <div
                          className={
                            sortedValue === item.label
                              ? "datetext pointer"
                              : "pointer"
                          }
                          onClick={() => {
                            setSortedValue(item.value);
                            setShowShortDrop(false);
                          }}
                        >
                          <p className="d-flex gap-">
                            {item.label}
                            {sortedValue === item.label && (
                              <p className="mb-0 ps-3">✓</p>
                            )}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </sortSection>
              </Col>

              <Col xl={4} className="add-col-item pe-0">
                <div className="p-3 pb-0">
                  {/* header pagination start */}
                  <div className="stock-custom-pagination">
                    <div>
                      {`${paginationObj.startRecordIndex} - ${paginationObj.endRecordIndex}  of  ${paginationObj.totalRecords}`}
                    </div>
                    <div className="pagination-buttons">
                      <div
                        className={`update-stock-pagination-button ${
                          paginationObj.currentPage === 1 ? "disabled" : ""
                        }`}
                        onClick={() =>
                          calculatePagination(paginationObj.currentPage - 1)
                        }
                      >
                        <BsChevronLeft />
                      </div>
                      <div className="pagination-current-page">
                        {paginationObj.currentPage}
                      </div>
                      <div
                        className={`update-stock-pagination-button ${
                          paginationObj.totalPages === 0 ||
                          paginationObj.totalPages === paginationObj.currentPage
                            ? "disabled"
                            : ""
                        }`}
                        onClick={() =>
                          calculatePagination(paginationObj.currentPage + 1)
                        }
                      >
                        <BsChevronRight />
                      </div>
                    </div>
                  </div>
                  {/* header pagination end */}
                </div>
              </Col>
            </Row>

            <div className="ascTableWrapper px-4">
              <table className="table">
                <thead>
                  <tr
                    className="tableHeading"
                    style={{
                      color: "#333333",
                      fontSize: "14px",
                      fontWeight: "700",
                    }}
                  >
                    <th>
                      {/* Date */}
                      {t("Date")}
                    </th>
                    <th>
                      {/* Hiring <br />
                      Order ID */}
                      {t("Hiring Order Id").slice(0, 6)}
                      <br />
                      {t("Hiring Order Id").slice(6)}
                    </th>
                    <th>
                      {/* Resource */}
                      {t("Resouces")}
                    </th>
                    <th>
                      {/* Wage */}
                      {t("Wage")}
                    </th>
                    <th>
                      {/* Start */}
                      {t("Start  ")}
                    </th>
                    <th>
                      {/* End */}
                      {t("End  ")}
                    </th>
                    <th style={{ width: "1%" }}>
                      {/* Status */}
                      {t("Status")}
                    </th>
                    <th></th>
                  </tr>
                </thead>

                <tbody
                  className="tabLine"
                  style={{
                    color: "#333333",
                    fontSize: "14px",
                    fontWeight: "400",
                  }}
                >
                  {/* {projectHiringListData
                    .slice(currentPage * perPage, (currentPage + 1) * perPage) */}
                  {paginationObj.records.map((item, index) => {
                    return (
                      <tr
                        className="asc_Table_Hover"
                        // title={item.clientname.length > 10 && item.clientname}
                      >
                        <td
                          // title={item?.workname?.length > 10 && item?.workname}
                          className="pointer"
                          // style={{
                          //   // for 3 dots 👇
                          //   // whiteSpace: "pre-wrap",
                          //   whiteSpace: "nowrap",
                          //   overflow: "hidden",
                          //   textOverflow: "ellipsis",
                          //   maxWidth: "10px",
                          // }}
                          onClick={() => {
                            setIsUpdateTime(true);
                            // setCreateWorkPopup(true);
                            setWorkID(item.projectHiringid);
                            // dispatch(FetchWorkById(item.projectHiringid));
                          }}
                        >
                          {moment(item.date).format("DD.MM.YYYY")}
                        </td>

                        <td>{item.hiringOrderID}</td>
                        <td>{item.resource}</td>

                        <td className="">
                          {europeanFormatWithSymbol(item.wage)}
                        </td>

                        <td className="">
                          {moment(item.start).format("DD.MM.YYYY")}
                        </td>

                        <td className="">
                          {moment(item.end).format("DD.MM.YYYY")}
                        </td>

                        <td>{item.status}</td>

                        <td className="position-relative">
                          <img
                            className="pointer"
                            src={Kebab}
                            alt=""
                            onClick={() => {
                              setKebabPopupShow(true);
                              setSelectedProjectHiringID(item.projectHiringid);
                            }}
                          />
                          {kebabPopupShow &&
                            item.projectHiringid ===
                              selectedProjectHiringID && (
                              <div className="companyKebabPopup p-3">
                                <div className="pointer text-end pe-2">
                                  <img
                                    src={Kebab}
                                    alt=""
                                    style={{ rotate: "90deg" }}
                                    onClick={() => {
                                      setKebabPopupShow(false);
                                    }}
                                  />
                                </div>
                                <div className="kebabTxt pointer">
                                  <div
                                    className="d-flex gap-2 position-relative"
                                    style={{
                                      background:
                                        changeStatusPopup && "#F1F1F1",
                                      borderRadius: changeStatusPopup && "8px",
                                    }}
                                    onClick={() => {
                                      // history.push({
                                      //   pathname: "/add-contact",
                                      //   state: {
                                      //     from: "CompanyList_Screen",
                                      //     companyName: item.clientname,
                                      //   },
                                      // });
                                      setChangeStatusPopup(!changeStatusPopup);
                                      setExtendPeriodPopup(false);
                                    }}
                                  >
                                    <img src={changeIcon} alt="" width={14} />
                                    <p>Change Status</p>
                                  </div>

                                  {changeStatusPopup && (
                                    <div
                                      className="w-100"
                                      style={{
                                        position: "absolute",
                                        right: "170px",
                                        top: "45px",
                                        borderRadius: "8px",
                                      }}
                                    >
                                      <div
                                        className="p-2 text-end"
                                        style={{
                                          background: "#E1E1E1",
                                          borderRadius: "8px 8px 0px 0px",
                                        }}
                                      >
                                        <img
                                          src={XiconCircle}
                                          alt=""
                                          width={16}
                                          className="ms-auto"
                                          onClick={() => {
                                            setChangeStatusPopup(false);
                                          }}
                                        />
                                      </div>
                                      <div
                                        // ref={status_Popup_Ref}
                                        className="asc_Search_Box w-100 ms- d-flex pointer"
                                        style={{
                                          border: "unset",
                                          borderRadius: "unset",
                                          background: "white",
                                          height: "40px",
                                          paddingTop: "10px",
                                        }}
                                      >
                                        <p
                                          className="asc_Client_Input_For_Long ps-3 m-0"
                                          onClick={() => {
                                            setStatusShow(!statusShow);
                                            setArrowOptionsRotate3(
                                              !arrowOptionsRotate3,
                                            );
                                          }}
                                        >
                                          <p className="m-0 selectedTxT">
                                            {status}
                                          </p>
                                        </p>

                                        <img
                                          src={DownArrowOption}
                                          className={
                                            arrowOptionsRotate3
                                              ? "upArrow mt-1"
                                              : "downArrow mt-1"
                                          }
                                          alt=""
                                          onClick={() => {
                                            setStatusShow(!status);
                                            setArrowOptionsRotate3(
                                              !arrowOptionsRotate3,
                                            );
                                          }}
                                        />

                                        {statusShow && (
                                          <div
                                            className="asc_Custom_Select_Outer pt-1"
                                            style={{
                                              borderTop: "none",
                                              border: "unset",
                                              background: "white",
                                            }}
                                          >
                                            <div className="">
                                              <p
                                                className={
                                                  status === "Requested"
                                                    ? "asc_Selected_Item ps-3 py-1 mb-1 d-flex justify-content-between"
                                                    : "ps-3 py-1 mb-1 hoverItem"
                                                }
                                                style={{ boxShadow: "unset" }}
                                                onClick={() => {
                                                  setStatus("Requested");
                                                  setStatusShow(false);
                                                  setArrowOptionsRotate3(false);
                                                  dispatch(
                                                    UpdateProjectHiringStatus(
                                                      item.projectHiringid,
                                                      process.env
                                                        .REACT_APP_REQUESTED,
                                                    ),
                                                  );
                                                }}
                                              >
                                                Requested
                                                {status === "Requested" && (
                                                  <p className="m-0 pe-2">✔</p>
                                                )}
                                              </p>
                                              <p
                                                className={
                                                  status === "Hired"
                                                    ? "asc_Selected_Item ps-3 py-1 mb-2 d-flex justify-content-between"
                                                    : "ps-3 py-1 mb-2 hoverItem"
                                                }
                                                style={{ boxShadow: "unset" }}
                                                onClick={() => {
                                                  setStatus("Hired");
                                                  setStatusShow(false);
                                                  setArrowOptionsRotate3(false);
                                                  dispatch(
                                                    UpdateProjectHiringStatus(
                                                      item.projectHiringid,
                                                      process.env
                                                        .REACT_APP_HIRED,
                                                    ),
                                                  );
                                                }}
                                              >
                                                Hired
                                                {status === "Hired" && (
                                                  <p className="m-0 pe-2">✔</p>
                                                )}
                                              </p>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}

                                  <div
                                    className="d-flex gap-2 position-relative"
                                    style={{
                                      background:
                                        extendPeriodPopup && "#F1F1F1",
                                      borderRadius: extendPeriodPopup && "8px",
                                    }}
                                    onClick={() => {
                                      // history.push({
                                      //   pathname: "/add-contact",
                                      //   state: {
                                      //     from: "CompanyList_Screen",
                                      //     companyName: item.clientname,
                                      //   },
                                      // });
                                      setExtendPeriodPopup(!extendPeriodPopup);
                                      setChangeStatusPopup(false);
                                    }}
                                  >
                                    <img src={calendar} alt="" width={14} />
                                    <p>Extend Period</p>
                                  </div>

                                  {extendPeriodPopup && (
                                    <div
                                      className=""
                                      style={{
                                        width: "400px",
                                        maxWidth: "40vw",
                                        position: "absolute",
                                        right: "200px",
                                        top: "45px",
                                        borderRadius: "8px",
                                        background: "#FFFFFF",
                                        boxShadow: "0px 6px 10px #3B455833",
                                      }}
                                    >
                                      <div
                                        className="d-flex justify-content-between p-1"
                                        style={{
                                          background: "#E4EDFA",
                                          borderRadius: "8px",
                                        }}
                                      >
                                        <p className="extend ps-3">
                                          Extend Period
                                        </p>
                                        <img
                                          src={XiconCircle}
                                          alt=""
                                          width={18}
                                          className="me-2"
                                          onClick={() => {
                                            setExtendPeriodPopup(false);
                                          }}
                                        />
                                      </div>

                                      <div className="row pt-3 ps-3">
                                        <div className="col-12 col-md-5">
                                          <p className="my-2">Starting Date</p>
                                        </div>
                                        <div className="col-12 col-md-5">
                                          <div
                                            className="projectManagerInput ps-4 flexContainer"
                                            id="CalendarCssTT22"
                                            style={{
                                              border: "none",
                                              height: "40px",
                                            }}
                                            ref={startingDate_Popup_Ref}
                                          >
                                            <img
                                              className="calendarIcon pointer"
                                              onClick={() =>
                                                setCalendarIsOpen((p) => !p)
                                              }
                                              src={calendar}
                                              alt=""
                                            />
                                            <AppDatePicker
                                              open={calendarIsOpen}
                                              selected={startingDate}
                                              onChange={(val) => {
                                                setStartingDate(val);
                                                setCalendarIsOpen(false);
                                              }}
                                              onSelect={(d, event) => {
                                                setDateError(false);
                                                event.preventDefault();
                                              }}
                                              isError={dateError}
                                              error={setDateError}
                                              dateFormat="dd/MM/yyyy"
                                            />
                                          </div>
                                          {dateError && (
                                            <div
                                              style={{
                                                display: "flex",
                                                gap: "5px",
                                                marginTop: "5px",
                                              }}
                                            >
                                              <div class="warning-icon">!</div>
                                              <div class="warning-message">
                                                Please select a valid date.
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>

                                      <div className="row ps-3">
                                        <div className="col-12 col-md-5">
                                          <p className="my-2">Ending Date</p>
                                        </div>
                                        <div className="col-12 col-md-5">
                                          <div
                                            className="projectManagerInput ps-4 flexContainer"
                                            id="CalendarCssTT22"
                                            style={{
                                              border: "none",
                                              height: "40px",
                                            }}
                                            ref={complitionDate_Popup_Ref}
                                          >
                                            <img
                                              className="calendarIcon pointer"
                                              onClick={() =>
                                                setCalendarIsOpen2((p) => !p)
                                              }
                                              src={calendar}
                                              alt=""
                                            />
                                            <AppDatePicker
                                              open={calendarIsOpen2}
                                              selected={endingDate}
                                              onChange={(val) => {
                                                setEndingDate(val);
                                                setCalendarIsOpen2(false);
                                              }}
                                              onSelect={(d, event) => {
                                                setDateError(false);
                                                event.preventDefault();
                                              }}
                                              isError={dateError}
                                              error={setDateError}
                                              dateFormat="dd/MM/yyyy"
                                            />
                                          </div>
                                          {dateError && (
                                            <div
                                              style={{
                                                display: "flex",
                                                gap: "5px",
                                                marginTop: "5px",
                                              }}
                                            >
                                              <div class="warning-icon">!</div>
                                              <div class="warning-message">
                                                Please select a valid date.
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>

                                      <div className="row ps-3">
                                        <div className="col-12 col-md-5">
                                          <p className="my-2">Charge Client</p>
                                        </div>
                                        <div className="col-12 col-md-5">
                                          <div
                                            className="projectManagerInput ps-4 assign_Probability_project gap-3"
                                            style={{
                                              border: "none",
                                              height: "40px",
                                            }}
                                          >
                                            <div className="mt-2 d-flex align-items-center gap-1 assignment_radio">
                                              <input
                                                type="radio"
                                                checked={
                                                  chargeClient === true ||
                                                  chargeClient === 1
                                                }
                                                style={{
                                                  fontSize: "12px",
                                                  width: "20px",
                                                  height: "20px",
                                                }}
                                                // value={planning}
                                                onChange={(e) => {
                                                  // setPlanning(e.target.checked);
                                                  setChargeClient(true);
                                                  // setTypeComp(e.target.value);
                                                }}
                                              />
                                              Yes
                                            </div>

                                            <div className="mt-2 d-flex align-items-center gap-1 assignment_radio">
                                              <input
                                                type="radio"
                                                checked={
                                                  chargeClient === false ||
                                                  chargeClient === 0
                                                }
                                                style={{
                                                  fontSize: "12px",
                                                  width: "20px",
                                                  height: "20px",
                                                }}
                                                // value={planning}
                                                onChange={(e) => {
                                                  // setPlanning(e.target.checked);
                                                  setChargeClient(false);
                                                  // setTypeComp(e.target.value);
                                                }}
                                              />
                                              No
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="my-3">
                                        <button
                                          id="ascButtonDisabled"
                                          className="button_invo mx-auto"
                                          onClick={(e) => {
                                            dispatch(
                                              UpdateProjectHiringExtendPeriod(
                                                item.projectHiringid,
                                                startingDate,
                                                endingDate,
                                                chargeClient,
                                              ),
                                            );
                                            setExtendPeriodPopup(false);
                                          }}
                                        >
                                          <p>Add</p>
                                        </button>
                                      </div>
                                    </div>
                                  )}

                                  <div
                                    className="d-flex gap-2"
                                    onClick={() => {
                                      // history.push({
                                      //   pathname: "/addProject",
                                      //   state: "/project",
                                      //   ascState: {
                                      //     from: "CompanyList_Screen",
                                      //     clientName: item.clientname,
                                      //     clientId: item.clientid,
                                      //   },
                                      // });
                                      dispatch(
                                        ProjectHireDelete(item.projectHiringid),
                                      );
                                    }}
                                  >
                                    <img src={bin} alt="" width={14} />
                                    <p>Delete</p>
                                  </div>
                                </div>
                              </div>
                            )}
                        </td>
                      </tr>
                    );
                  })}
                  {projectHiringListData.length === 0 && (
                    <span className="noDataDisplay">
                      {/* No data to display! */}
                      {t("No data to display!\n")}
                    </span>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <CreateWork
            createWorkPopup={createWorkPopup}
            setCreateWorkPopup={setCreateWorkPopup}
            projectid={projectid}
            projectHireCreateRes={projectHireCreateRes}
            projectHiringListData={projectHiringListData}
            isUpdateTime={isUpdateTime}
            setIsUpdateTime={setIsUpdateTime}
            workID={workID}
            setWorkID={setWorkID}
            projectHireDeleteRes={projectHireDeleteRes}
            activeAllFromList={activeAllFromList}
            setActiveAllFromList={setActiveAllFromList}
            goComplete={goComplete}
            setGoComplete={setGoComplete}
            authorisedCoWorkerData={authorisedCoWorkerData}
            setAuthorisedCoWorkerData={setAuthorisedCoWorkerData}
          />
        </div>
      )}
    </>
  );
};

const CreateWork = ({
  createWorkPopup,
  setCreateWorkPopup,
  projectid,
  projectHireCreateRes,
  projectHiringListData,
  isUpdateTime,
  setIsUpdateTime,
  workID,
  setWorkID,
  projectHireDeleteRes,
  activeAllFromList,
  setActiveAllFromList,
  goComplete,
  setGoComplete,
  UpdatePOTaskStatusResponse,
  changeStatus,
  authorisedCoWorkerData,
  setAuthorisedCoWorkerData,
}) => {
  const dispatch = useDispatch();
  const ViewBy_Popup_Ref = useRef(null);
  const startingDate_Popup_Ref = useRef(null);
  const complitionDate_Popup_Ref = useRef(null);
  const wageRate_Popup_Ref = useRef(null);
  const status_Popup_Ref = useRef(null);

  const projectcode = window.localStorage.getItem("projectcode");
  const firstname = window.localStorage.getItem("firstname");

  const fetchActiveUser = useSelector((state) => state.user.fetchActiveUser);
  const fetchWorkTaskByIdRes = useSelector(
    (state) => state.user.fetchWorkTaskByIdRes
  );

  // view by start.
  const [arrowOptionsRotate, setArrowOptionsRotate] = useState(false);
  const [companyShow, setCompanyShow] = useState(false);
  const [viewByTxtShow, setViewByTxtShow] = useState("Temporary");
  // view by end.

  // wage rate by start.
  const [arrowOptionsRotate2, setArrowOptionsRotate2] = useState(false);
  const [wageRateShow, setWageRateShow] = useState(false);
  const [wageRate, setWageRate] = useState("");
  const [wageType, setWageType] = useState("Hourly");
  // wage rate by end.

  // status by start.
  const [arrowOptionsRotate3, setArrowOptionsRotate3] = useState(false);
  const [statusShow, setStatusShow] = useState(false);
  const [status, setStatus] = useState("Requested");
  // status by end.

  const [planning, setPlanning] = useState(false);
  const [createdat, setCreatedat] = useState(new Date());

  const [calendarIsOpen, setCalendarIsOpen] = useState(false);
  const [calendarIsOpen2, setCalendarIsOpen2] = useState(false);
  const [startingDate, setStartingDate] = useState(new Date());
  const [endingDate, setEndingDate] = useState(new Date());
  const [dateError, setDateError] = useState(false);

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      ViewBy_Popup_Ref.current &&
      !ViewBy_Popup_Ref.current.contains(event.target)
    ) {
      setCompanyShow(false);
      setArrowOptionsRotate(false);
    }
    if (
      startingDate_Popup_Ref.current &&
      !startingDate_Popup_Ref.current.contains(event.target)
    ) {
      setCalendarIsOpen(false);
    }
    if (
      complitionDate_Popup_Ref.current &&
      !complitionDate_Popup_Ref.current.contains(event.target)
    ) {
      setCalendarIsOpen2(false);
    }
    if (
      wageRate_Popup_Ref.current &&
      !wageRate_Popup_Ref.current.contains(event.target)
    ) {
      setWageRateShow(false);
      setArrowOptionsRotate2(false);
    }
    if (
      status_Popup_Ref.current &&
      !status_Popup_Ref.current.contains(event.target)
    ) {
      setStatusShow(false);
      setArrowOptionsRotate3(false);
    }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  return (
    createWorkPopup && (
      <div
        className="hiringOrderPopupDiv position-absolute"
        style={{ top: "15px", left: "180px" }}
      >
        <div className="hiringOrder pt-3 px-4">
          <p className="hiringText">Hiring Order</p>
          <p className="idText">ID &nbsp;{projectcode}</p>
          <img
            src={XiconCircle}
            className="pointer"
            width={15}
            alt=""
            onClick={(e) => {
              setCreateWorkPopup(false);
            }}
          />
        </div>

        <div className="hiringOrderUnder pt-3 px-4">
          <div className="row" style={{ borderBottom: "1px dotted" }}>
            <div className="col-12 col-md-5">
              <p className="my-2">Contract type</p>
            </div>
            <div className="col-12 col-md-5">
              <div
                ref={ViewBy_Popup_Ref}
                className="asc_Search_Box w-100 ms-2 d-flex pointer"
                style={{
                  border: "unset",
                  background: "white",
                  height: "40px",
                  paddingTop: "10px",
                }}
              >
                <p
                  className="asc_Client_Input_For_Long ps-3"
                  onClick={() => {
                    setCompanyShow(!companyShow);
                    setArrowOptionsRotate(!arrowOptionsRotate);
                  }}
                >
                  {/* {projectName ? projectName : "Select a Project"} */}
                  <p className="mb-0 selectedTxT">{viewByTxtShow}</p>
                </p>

                <img
                  src={DownArrowOption}
                  className={
                    arrowOptionsRotate ? "upArrow mt-1" : "downArrow mt-1"
                  }
                  alt=""
                  onClick={() => {
                    setCompanyShow(!companyShow);
                    setArrowOptionsRotate(!arrowOptionsRotate);
                  }}
                />

                {companyShow && (
                  <div
                    className="asc_Custom_Select_Outer pt-1"
                    style={{
                      borderTop: "none",
                      border: "unset",
                      background: "white",
                    }}
                  >
                    <div className="">
                      <p
                        className={
                          viewByTxtShow === "Temporary"
                            ? "asc_Selected_Item ps-3 py-1 mb-1 d-flex justify-content-between"
                            : "ps-3 py-1 mb-1 hoverItem"
                        }
                        style={{ boxShadow: "unset" }}
                        onClick={() => {
                          setViewByTxtShow("Temporary");
                          setCompanyShow(false);
                          setArrowOptionsRotate(false);
                        }}
                      >
                        Temporary
                        {viewByTxtShow === "Temporary" && (
                          <p className="mb-0 pe-2">✔</p>
                        )}
                      </p>
                      <p
                        className={
                          viewByTxtShow === "Undefined time"
                            ? "asc_Selected_Item ps-3 py-1 mb-1 d-flex justify-content-between"
                            : "ps-3 py-1 mb-1 hoverItem"
                        }
                        style={{ boxShadow: "unset" }}
                        onClick={() => {
                          setViewByTxtShow("Undefined time");
                          setCompanyShow(false);
                          setArrowOptionsRotate(false);
                        }}
                      >
                        Undefined time
                        {viewByTxtShow === "Undefined time" && (
                          <p className="mb-0 pe-2">✔</p>
                        )}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="row" style={{ borderBottom: "1px dotted" }}>
            <div className="col-12 col-md-5">
              <p className="my-2">Starting Date</p>
            </div>
            <div className="col-12 col-md-5">
              <div
                className="projectManagerInput ps-4 flexContainer"
                id="CalendarCssTT22"
                style={{ border: "none", height: "40px" }}
                ref={startingDate_Popup_Ref}
              >
                <img
                  className="calendarIcon pointer"
                  onClick={() => setCalendarIsOpen((p) => !p)}
                  src={calendar}
                  alt=""
                />
                <AppDatePicker
                  open={calendarIsOpen}
                  selected={startingDate}
                  onChange={(val) => {
                    setStartingDate(val);
                    setCalendarIsOpen(false);
                  }}
                  onSelect={(d, event) => {
                    setDateError(false);
                    event.preventDefault();
                  }}
                  isError={dateError}
                  error={setDateError}
                  dateFormat="dd/MM/yyyy"
                />
              </div>
              {dateError && (
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    marginTop: "5px",
                  }}
                >
                  <div class="warning-icon">!</div>
                  <div class="warning-message">Please select a valid date.</div>
                </div>
              )}
            </div>
          </div>

          <div className="row" style={{ borderBottom: "1px dotted" }}>
            <div className="col-12 col-md-5">
              <p className="my-2">Ending Date</p>
            </div>
            <div className="col-12 col-md-5">
              <div
                className="projectManagerInput ps-4 flexContainer"
                id="CalendarCssTT22"
                style={{ border: "none", height: "40px" }}
                ref={complitionDate_Popup_Ref}
              >
                <img
                  className="calendarIcon pointer"
                  onClick={() => setCalendarIsOpen2((p) => !p)}
                  src={calendar}
                  alt=""
                />
                <AppDatePicker
                  open={calendarIsOpen2}
                  selected={endingDate}
                  onChange={(val) => {
                    setEndingDate(val);
                    setCalendarIsOpen2(false);
                  }}
                  onSelect={(d, event) => {
                    setDateError(false);
                    event.preventDefault();
                  }}
                  isError={dateError}
                  error={setDateError}
                  dateFormat="dd/MM/yyyy"
                />
              </div>
              {dateError && (
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    marginTop: "5px",
                  }}
                >
                  <div class="warning-icon">!</div>
                  <div class="warning-message">Please select a valid date.</div>
                </div>
              )}
            </div>
          </div>

          <div className="row" style={{ borderBottom: "1px dotted" }}>
            <div className="col-12 col-md-5">
              <p className="my-2">Wage Rate</p>
            </div>
            <div className="col-3 pt-2 ps-1 pe-0">
              <CurrencyInput
                className="ps-3 fw-normal"
                style={{
                  border: "none",
                  width: "100px",
                  color: "#A5A5A5",
                }}
                placeholder="0"
                name="creditBalance"
                value={wageRate}
                onChangeEvent={(event, maskedValue, floatValue) => {
                  setWageRate(floatValue);
                }}
                decimalSeparator=","
                thousandSeparator="."
                precision="2"
                // for normal input👇
                // decimalSeparator=""
                // thousandSeparator=""
                // precision=""
                // for normal input👆
                allowEmpty={true}
                prefix="€ "
              />
            </div>
            <div className="col-4 ps-0">
              <div
                ref={wageRate_Popup_Ref}
                className="asc_Search_Box w-100 ms-2 d-flex pointer"
                style={{
                  border: "unset",
                  background: "white",
                  height: "40px",
                  paddingTop: "10px",
                }}
              >
                <p
                  className="asc_Client_Input_For_Long ps-3"
                  onClick={() => {
                    setWageRateShow(!wageRateShow);
                    setArrowOptionsRotate2(!arrowOptionsRotate2);
                  }}
                >
                  {/* {projectName ? projectName : "Select a Project"} */}
                  <p className="mb-0 selectedTxT">{wageType}</p>
                </p>

                <img
                  src={DownArrowOption}
                  className={
                    arrowOptionsRotate2 ? "upArrow mt-1" : "downArrow mt-1"
                  }
                  alt=""
                  onClick={() => {
                    setWageRateShow(!wageRateShow);
                    setArrowOptionsRotate2(!arrowOptionsRotate2);
                  }}
                />

                {wageRateShow && (
                  <div
                    className="asc_Custom_Select_Outer pt-1"
                    style={{
                      borderTop: "none",
                      border: "unset",
                      background: "white",
                    }}
                  >
                    <div className="">
                      <p
                        className={
                          wageType === "Hourly"
                            ? "asc_Selected_Item ps-3 py-1 mb-1 d-flex justify-content-between"
                            : "ps-3 py-1 mb-1 hoverItem"
                        }
                        style={{ boxShadow: "unset" }}
                        onClick={() => {
                          setWageType("Hourly");
                          setWageRateShow(false);
                          setArrowOptionsRotate2(false);
                        }}
                      >
                        Hourly
                        {wageType === "Hourly" && (
                          <p className="mb-0 pe-2">✔</p>
                        )}
                      </p>
                      <p
                        className={
                          wageType === "Daily"
                            ? "asc_Selected_Item ps-3 py-1 mb-1 d-flex justify-content-between"
                            : "ps-3 py-1 mb-1 hoverItem"
                        }
                        style={{ boxShadow: "unset" }}
                        onClick={() => {
                          setWageType("Daily");
                          setWageRateShow(false);
                          setArrowOptionsRotate2(false);
                        }}
                      >
                        Daily
                        {wageType === "Daily" && <p className="mb-0 pe-2">✔</p>}
                      </p>

                      <p
                        className={
                          wageType === "Fixed"
                            ? "asc_Selected_Item ps-3 py-1 mb-1 d-flex justify-content-between"
                            : "ps-3 py-1 mb-1 hoverItem"
                        }
                        style={{ boxShadow: "unset" }}
                        onClick={() => {
                          setWageType("Fixed");
                          setWageRateShow(false);
                          setArrowOptionsRotate2(false);
                        }}
                      >
                        Fixed
                        {wageType === "Fixed" && <p className="mb-0 pe-2">✔</p>}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="row" style={{ borderBottom: "1px dotted" }}>
            <div className="col-12 col-md-5">
              <p className="my-2">Status</p>
            </div>
            <div className="col-12 col-md-5">
              <div
                ref={status_Popup_Ref}
                className="asc_Search_Box w-100 ms-2 d-flex pointer"
                style={{
                  border: "unset",
                  background: "white",
                  height: "40px",
                  paddingTop: "10px",
                }}
              >
                <p
                  className="asc_Client_Input_For_Long ps-3"
                  onClick={() => {
                    setStatusShow(!statusShow);
                    setArrowOptionsRotate3(!arrowOptionsRotate3);
                  }}
                >
                  {/* {projectName ? projectName : "Select a Project"} */}
                  <p className="mb-0 selectedTxT">{status}</p>
                </p>

                <img
                  src={DownArrowOption}
                  className={
                    arrowOptionsRotate3 ? "upArrow mt-1" : "downArrow mt-1"
                  }
                  alt=""
                  onClick={() => {
                    setStatusShow(!status);
                    setArrowOptionsRotate3(!arrowOptionsRotate3);
                  }}
                />

                {statusShow && (
                  <div
                    className="asc_Custom_Select_Outer pt-1"
                    style={{
                      borderTop: "none",
                      border: "unset",
                      background: "white",
                    }}
                  >
                    <div className="">
                      <p
                        className={
                          status === "Requested"
                            ? "asc_Selected_Item ps-3 py-1 mb-1 d-flex justify-content-between"
                            : "ps-3 py-1 mb-1 hoverItem"
                        }
                        style={{ boxShadow: "unset" }}
                        onClick={() => {
                          setStatus("Requested");
                          setStatusShow(false);
                          setArrowOptionsRotate3(false);
                        }}
                      >
                        Requested
                        {status === "Requested" && (
                          <p className="mb-0 pe-2">✔</p>
                        )}
                      </p>
                      <p
                        className={
                          status === "Hired"
                            ? "asc_Selected_Item ps-3 py-1 mb-2 d-flex justify-content-between"
                            : "ps-3 py-1 mb-2 hoverItem"
                        }
                        style={{ boxShadow: "unset" }}
                        onClick={() => {
                          setStatus("Hired");
                          setStatusShow(false);
                          setArrowOptionsRotate3(false);
                        }}
                      >
                        Hired
                        {status === "Hired" && <p className="mb-0 pe-2">✔</p>}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="row" style={{ borderBottom: "1px dotted" }}>
            <div className="col-12 col-md-5">
              <p className="my-2">Add to planning</p>
            </div>
            <div className="col-12 col-md-5">
              <div
                className="projectManagerInput ps-2 assign_Probability_project gap-3"
                style={{ border: "none", height: "40px" }}
              >
                <div className="mt-2 d-flex align-items-center gap-1 assignment_radio">
                  <input
                    type="radio"
                    checked={planning === true}
                    style={{
                      fontSize: "12px",
                      width: "20px",
                      height: "20px",
                    }}
                    // value={planning}
                    onChange={(e) => {
                      // setPlanning(e.target.checked);
                      setPlanning(true);
                      // setTypeComp(e.target.value);
                    }}
                  />
                  Yes
                </div>

                <div className="mt-2 d-flex align-items-center gap-1 assignment_radio">
                  <input
                    type="radio"
                    checked={planning === false}
                    style={{
                      fontSize: "12px",
                      width: "20px",
                      height: "20px",
                    }}
                    // value={planning}
                    onChange={(e) => {
                      // setPlanning(e.target.checked);
                      setPlanning(false);
                      // setTypeComp(e.target.value);
                    }}
                  />
                  No
                </div>
              </div>
            </div>
          </div>

          <div className="my-3">
            <button
              id="ascButtonDisabled"
              disabled={
                wageRate === "" ||
                wageRate === 0 ||
                authorisedCoWorkerData[0]?.id === ""
              }
              className="button_invo mt-3 pt-3 mx-auto"
              onClick={(e) => {
                dispatch(
                  ProjectHireCreate(
                    projectid,
                    // contacttypeid,
                    viewByTxtShow === "Temporary"
                      ? process.env.REACT_APP_TEMPORARY
                      : process.env.REACT_APP_UNDEFINED_TIME,
                    authorisedCoWorkerData[0]?.id,
                    startingDate,
                    endingDate,
                    wageRate,
                    wageType,
                    status === "Requested"
                      ? process.env.REACT_APP_REQUESTED
                      : process.env.REACT_APP_HIRED,
                    planning,
                    createdat,
                    firstname
                  )
                );
                setCreateWorkPopup(false);
                setAuthorisedCoWorkerData([]);
                toast(
                  <NotificationContent
                    primaryMessage="The new hiring order was successfully done."
                    secondaryMessage="The manager was notified to proceed with the hire."
                  />,
                  {
                    icon: () => <img src={LogoSmall} alt="Logo" width={35} />,
                    className: "app-notification",
                    closeButton: true,
                    autoClose: 3000,
                    hideProgressBar: true,
                  }
                );
              }}
            >
              <p>Add</p>
            </button>
          </div>
        </div>
      </div>
    )
  );
};

const NotificationContent = ({ primaryMessage, secondaryMessage }) => (
  <div className="app-notification-container">
    <div className="d-flex flex-column gap-1">
      <div>
        {primaryMessage}
        {secondaryMessage}
      </div>
    </div>
  </div>
);
export default AddProjectHiring;
